import * as Mod1 from "./discourse/components/docs-category";
import * as Mod2 from "./discourse/components/docs-search";
import * as Mod3 from "./discourse/components/docs-tag";
import * as Mod4 from "./discourse/components/docs-topic";
import * as Mod5 from "./discourse/controllers/docs";
import * as Mod6 from "./discourse/controllers/docs/index";
import * as Mod7 from "./discourse/docs-route-map";
import * as Mod8 from "./discourse/initializers/setup-docs";
import * as Mod9 from "./discourse/models/docs";
import * as Mod10 from "./discourse/routes/docs";
import * as Mod11 from "./discourse/routes/docs/index";
import * as Mod12 from "./discourse/templates/docs";
import * as Mod13 from "./discourse/templates/docs/index";
import * as Mod14 from "./lib/get-docs";
const compatModules = {
  "discourse/components/docs-category": Mod1,
  "discourse/components/docs-search": Mod2,
  "discourse/components/docs-tag": Mod3,
  "discourse/components/docs-topic": Mod4,
  "discourse/controllers/docs": Mod5,
  "discourse/controllers/docs/index": Mod6,
  "discourse/docs-route-map": Mod7,
  "discourse/initializers/setup-docs": Mod8,
  "discourse/models/docs": Mod9,
  "discourse/routes/docs": Mod10,
  "discourse/routes/docs/index": Mod11,
  "discourse/templates/docs": Mod12,
  "discourse/templates/docs/index": Mod13,
  "lib/get-docs": Mod14,
};
export { compatModules };
export default compatModules;
